import { render, staticRenderFns } from "./EmailForm.vue?vue&type=template&id=d027a6fa&scoped=true&"
import script from "./EmailForm.vue?vue&type=script&lang=ts&"
export * from "./EmailForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027a6fa",
  null
  
)

export default component.exports